async function processApiResponse(response, retryFetch) {
  if (response.ok) {
    return response.json();
  } else {
    if (response.status >= 400 && response.status < 600) {
      throw new Error(`Oops, the server messed up ¯\_(ツ)_/¯`);
    }
    return response.json();
  }
}

class API {
  static async get({
    url,
    params = {},
    headers
  }) {
    const apiUrl = new URL(url);

    Object.keys(params).forEach((key) => {
      apiUrl.searchParams.append(key, params[key])
    });

    const apiHeaders = {
      "Content-Type": "application/json",
      ...headers
    };

    const performFetch = () => fetch(apiUrl, {
      method: "GET",
      mode: "cors",
      headers: {
        ...apiHeaders
      },
    }).then((response) => {
      return processApiResponse(response, performFetch);
    });

    return performFetch();
  }

  static async post({
    url,
    params = {},
    headers
  }) {
    const apiUrl = new URL(url);

    const apiHeaders = {
      "Content-Type": "application/json",
      ...headers
    };

    const performFetch = () => fetch(apiUrl, {
      method: "POST",
      mode: "cors",
      headers: {
        ...apiHeaders
      },
      body: JSON.stringify(params)
    }).then((response) => {
      return processApiResponse(response, performFetch);
    });

    return performFetch();
  }

  static async put({
    url,
    params = {},
    headers
  }) {
    const apiUrl = new URL(url);

    const apiHeaders = {
      "Content-Type": "application/json",
      ...headers
    };

    const performFetch = () => fetch(apiUrl, {
      method: "PUT",
      mode: "cors",
      headers: {
        ...apiHeaders
      },
      body: JSON.stringify(params)
    }).then((response) => {
      return processApiResponse(response, performFetch);
    });

    return performFetch();
  }
}

export default API;